<template>
  <div class="content">
    <h1>Privacy Policy</h1>
    <div class="text-left px-4" v-html="compiledMarkdown" />
  </div>
</template>


<script>
import marked from 'marked';
export default {
  computed: {
    compiledMarkdown: function () {
      return marked(this.$root.$data.images.privacy)
    }
  },
  head: {
    title() {
      return {
        inner: "Privacy"
      }
    },
  }

}
</script>